var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m14.773 12.652-1.06-1.062 1.06-1.06A3.75 3.75 0 1 0 9.47 5.226L8.41 6.288l-1.062-1.06L8.41 4.166a5.25 5.25 0 1 1 7.425 7.425l-1.061 1.06zm-2.121 2.121-1.061 1.06A5.25 5.25 0 0 1 4.166 8.41l1.061-1.06 1.06 1.061-1.06 1.06a3.75 3.75 0 1 0 5.303 5.304l1.06-1.06 1.062 1.06Zm-.531-7.955 1.061 1.061-5.303 5.303-1.061-1.06z"
  })));
};
export default SvgLink;